import React, { Fragment, useState } from "react";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SingleQuestion from "../singleQuestion/singleQuestion";
import { Button } from "@material-ui/core";

const SELLER_SECTION = "פרטי המוכרים";
const BUYER_SECTION = "פרטי הקונים";
const THIRD_SECTION = "צד שלישי";

function SectionPanel(props) {
  return (
    <ExpansionPanel
      expanded={props.isSectionExpended}
      onChange={() => {
        props.handlePanelChange(props.panelIndex);
      }}
    >
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className="questions-page-wrapper">
        <h5 className="mb-0">{props.sectionName}</h5>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <div className="questionnaire-container">
          {props.questions.map((question, j) => {
            return (
              <Fragment key={"question" + j}>
                {props.isQuestionShown(question) ? (
                  <SingleQuestion
                    val={props.curJsonData[getRightQuestionKey(question)]}
                    question={question}
                    handleFieldChange={props.handleFieldChange}
                    panelIndex={props.panelIndex}
                    handleCheckboxChange={props.handleCheckboxChange}
                    handleFirstInteractionWithEle={props.handleFirstInteractionWithEle}
                  />
                ) : null}
              </Fragment>
            );
          })}
          {/* if extra sellers or buyers */}
          {displayAddSection(props.sectionName)
            ? getRightType(props.sectionName).map((extraClientsQuestions, indexOfClient) => {
                return (
                  <Fragment key={"asdsa" + indexOfClient}>
                    <div className="full-line"></div>
                    <div className="full-line">
                      <i
                        onClick={() => {
                          props.removeExtraClientsFromDeal(props.sectionName, indexOfClient);
                        }}
                        className="material-icons width40 delete-color pointer"
                      >
                        delete
                      </i>
                      <span className="underline">לקוח מספר {indexOfClient + 2}</span>
                    </div>
                    {extraClientsQuestions.map((question, j2) => {
                      return (
                        <Fragment key={"sdas" + j2}>
                          {props.isQuestionShown(question) ? (
                            <SingleQuestion
                              val={props.curJsonData[getRightQuestionKey(question)]}
                              question={question}
                              handleFieldChange={props.handleFieldChange}
                              panelIndex={props.panelIndex}
                              handleCheckboxChange={props.handleCheckboxChange}
                              handleFirstInteractionWithEle={props.handleFirstInteractionWithEle}
                            />
                          ) : null}
                        </Fragment>
                      );
                    })}
                  </Fragment>
                );
              })
            : null}
        </div>
      </ExpansionPanelDetails>
      {displayPlusBtn(props.sectionName) ? (
        <div className="add-seller-buyer-wrapper">
          <Button
            onClick={() => {
              props.addAnotherClientToDeal(props.sectionName);
            }}
            className="send-client-email-btn"
            variant="contained"
            size="small"
          >
            <i className="material-icons width40">add</i>
          </Button>
        </div>
      ) : null}
    </ExpansionPanel>
  );

  function getRightType(sectionName) {
    if (sectionName === SELLER_SECTION) return props.sellersData;
    else if (sectionName === BUYER_SECTION) return props.buyersData;
    return props.thirdData;
  }

  function displayAddSection(sectionName) {
    if (sectionName === SELLER_SECTION || sectionName === BUYER_SECTION || sectionName === THIRD_SECTION) return true;
    return false;
  }

  function displayPlusBtn(sectionName) {
    if (displayAddSection(sectionName)) {
      if (sectionName === SELLER_SECTION && props.sellersData.length >= 2) return false;
      if (sectionName === BUYER_SECTION && props.buyersData.length >= 2) return false;
      if (props.thirdData.length >= 2) return false;
      return true;
    }

    return false;
  }

  function getRightQuestionKey(question) {
    if (question.type === "checkbox" || question.type === "radio") return question.optionsKey;
    return question.key;
  }
}

export default SectionPanel;
